import HomeTemplate from '../templates/HomeTemplate.jsx'
import { SITE_NAME, SITE_URL } from '../utils/seo.js'

const title = `Convert Video to MP3 on Mobile – ${SITE_NAME}`
const description = 'Convert video to MP3 on your iPhone or Android phone. FastAudio works on any mobile browser — no app download required. Fast, free, and mobile-optimised.'
const canonical = `${SITE_URL}/mobile-convert`

export default function MobileConvert() {
  return (
    <HomeTemplate
      provider="generic"
      title={title}
      description={description}
      canonical={canonical}
      badge="Works on iPhone & Android"
      heading={
        <>
          Convert to MP3{' '}
          <span className="text-gradient">on Mobile</span>
        </>
      }
      subheading="FastAudio is fully optimised for mobile devices. Open your browser, paste a video link, and download your MP3 — no app required, works on iPhone and Android."
    />
  )
}
